module.exports = __webpack_public_path__ + "static/js/mailMerges.57c2c25d.chunk.worker.js"